/**
 * FAQ for the /enterprise/ hub. One array feeds both the FAQPage JSON-LD
 * (<StructuredData type="faq">) and the visible accordion, and every question
 * and answer is an i18n key in ms.json and zh.json. Lives outside the page
 * component so Jest can import it.
 */
export interface HubFaq {
  question: string;
  answer: string;
}

export const hubFaqs: HubFaq[] = [
  {
    question: "Which enterprise brands can Anchor Sprint supply in Malaysia?",
    answer:
      "We focus on a short list of brands, grouped as AI and compute (NVIDIA DGX Spark, NVIDIA GPUs, OpenAI, Claude licences and Alibaba Cloud Model Studio), cloud and observability (Alibaba Cloud and TrueWatch), software licences (Microsoft, Red Hat, Adobe, GitHub Enterprise and SonarQube) and hardware (Dell Technologies and Lenovo). Every order is quoted in Ringgit.",
  },
  {
    question: "Is there a minimum order?",
    answer:
      "We specialise in orders of 10+ units, seats or subscriptions, or RM5,000+ a month for usage-based services such as OpenAI models via Azure OpenAI, Alibaba Cloud and TrueWatch. Smaller enquiries are still welcome, but buying direct is usually faster.",
  },
  {
    question: "Are you a distributor or a reseller?",
    answer:
      "A reseller, not a distributor. We source through authorised channels and quote in Ringgit. Where we hold a partner status, the brand's card or page says so: authorised reseller for Microsoft (including GitHub Enterprise), Dell, Lenovo, NVIDIA DGX Spark, Red Hat, Alibaba Cloud and TrueWatch, Google Workspace reseller, Adobe Certified Reseller and Sonar reseller partner. Claude licences we procure and manage for you.",
  },
  {
    question: "How do I get a price?",
    answer:
      "Enterprise pricing is quote-based: send the brand, quantity and use case through our enquiry form and we return a quotation in Ringgit, usually within two working days. We do not publish list prices because distribution pricing moves with volume and program tier.",
  },
  {
    question: "Do quotes include SST and e-invoicing?",
    answer:
      "Yes. Quotations are issued in RM with SST treatment stated, and invoices are issued through MyInvois in line with Malaysia's e-invoicing requirements.",
  },
  {
    question: "Can you handle renewals for licences we bought elsewhere?",
    answer:
      "Usually, yes. Most subscription licences can be renewed or co-termed through our channel even if the original purchase was elsewhere — send the renewal date and current agreement through the enquiry form and we will confirm.",
  },
];
